import type { VolCoreWidgetKind, VolWidgetKind } from "./volWorkstationTypes";
import { CORRELATION_WIDGET_KINDS } from "../../../widgets/correlation/correlationWidgetTypes";
import { CORRELATION_WIDGET_DEFAULTS } from "../../../widgets/correlation/correlationWidgetDefaults";

export type VolWidgetLayoutDefaults = {
  w: number;
  h: number;
  minW?: number;
  minH?: number;
  x?: number;
  y?: number;
};

export const VOL_WIDGET_LAYOUT_DEFAULTS: Record<VolCoreWidgetKind, VolWidgetLayoutDefaults> = {
  "vol-surface-3d": { w: 14, h: 24, minW: 8, minH: 12 },
  "vol-term": { w: 10, h: 12, minW: 6, minH: 8 },
  "vol-skew": { w: 10, h: 12, minW: 6, minH: 8 },
  "vol-calibration": { w: 16, h: 18, minW: 8, minH: 10 },
  "vol-controls": { w: 8, h: 8, minW: 4, minH: 4 },
  "vol-binding": { w: 10, h: 14, minW: 6, minH: 8 },
};

export const VOL_WIDGET_TITLES: Record<VolCoreWidgetKind, string> = {
  "vol-surface-3d": "3D Vol Surface",
  "vol-term": "Term Structure",
  "vol-skew": "Vol Skew",
  "vol-calibration": "Calibration",
  "vol-controls": "Chart Controls",
  "vol-binding": "Instrument Binding",
};

export const ALL_VOL_CORE_WIDGET_KINDS = Object.keys(
  VOL_WIDGET_LAYOUT_DEFAULTS,
) as VolCoreWidgetKind[];

export const ALL_VOL_WIDGET_KINDS: VolWidgetKind[] = [
  ...ALL_VOL_CORE_WIDGET_KINDS,
  ...CORRELATION_WIDGET_KINDS,
];

export function volWidgetTitle(kind: VolWidgetKind): string {
  if (kind.startsWith("corr-")) return CORRELATION_WIDGET_DEFAULTS[kind as keyof typeof CORRELATION_WIDGET_DEFAULTS].title;
  return VOL_WIDGET_TITLES[kind as VolCoreWidgetKind];
}
